"use strict";
/**
 * NeXt-TDNN Web - Browser-based speaker verification using NeXt-TDNN
 *
 * Simplified API that exposes only essential functionality:
 * - Model loading
 * - Audio processing (handled internally)
 * - Score output
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeakerVerification = void 0;
// Main API - only expose the simplified SpeakerVerification class
var easy_api_1 = require("./easy-api");
Object.defineProperty(exports, "SpeakerVerification", { enumerable: true, get: function () { return easy_api_1.SpeakerVerification; } });
// Default export for UMD builds - only expose SpeakerVerification
exports.default = {
    SpeakerVerification: require('./easy-api').SpeakerVerification
};
